import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import AdvertDetail from "components/AdvertDetail";
import {formatPhone} from "helpers/phone";
import {openModal} from "../../../../actions/modal";
import {connect} from "react-redux";

class ConversationPlaceholder extends React.Component {
    static propTypes = {
        advert: PropTypes.object.isRequired,
        openAdvertEdit: PropTypes.func.isRequired,
    };

    render() {
        const {advert, openAdvertEdit} = this.props;

        return (
            <div className="conversation--blank">
                <div className="conversation--blank__title">
                    <FormattedMessage tagName="h2" id="conversation.blank.title"
                                      defaultMessage="Welcome to placenevolani.cz"/>
                    <FormattedMessage id="conversation.blank.text"
                                      defaultMessage="No conversation available"/>
                </div>
                <hr/>
                <div className="conversation--blank__profile">
                    <FormattedMessage id="conversation.blank.profile.title" defaultMessage="Your profile" tagName="h3"/>
                    <AdvertDetail advert={advert}/>

                    <a tabIndex={2} onClick={openAdvertEdit} className="clickable">
                        <FormattedMessage id="conversation.advert.edit_info" defaultMessage="Change info"/>
                    </a>

                    <div className="mt-4 mb-3">
                        <strong>
                            <FormattedMessage id="advert_modal.assigned_number_title"
                                              defaultMessage="Assigned number"/>
                        </strong>
                        {advert.publicNumbers.map((number, idx) => (
                            <div key={'publicNumber-' + idx} className="py-2 conversation--blank__profile--number">
                                <strong>{formatPhone(number)}</strong>
                            </div>
                        ))}
                        <span className="text-muted">
                        <FormattedMessage id="conversation.blank.phone_number.text"
                                          defaultMessage="Your customers can call you on this number"/>
                        </span>
                    </div>

                    <div>
                        <span className="text-muted">
                            <FormattedMessage id="advert.detail.voice_price"
                                              defaultMessage="Call price (per minute)"/>: <strong className="text-dark">{advert.priceLevelVoice.description}</strong>
                        </span>
                        <br/>
                        {advert.priceLevelText &&
                        <span className="text-muted">
                            <FormattedMessage id="advert.detail.text_price"
                                              defaultMessage="SMS price"/>: <strong className="text-dark">{advert.priceLevelText.description}</strong>
                        </span>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    state => ({}),
    dispatch => ({
        openAdvertEdit: () => dispatch(openModal('advertEdit'))
    })
)(ConversationPlaceholder);


// WEBPACK FOOTER //
// ./src/containers/Conversations/Content/ConversationPlaceholder/ConversationPlaceholder.jsx